import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OutlineSmallButton, PrimaryButton,} from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import { EDGE_SMALL_OUTLINE_BUTTONS, EDGE_SMALL_OUTLINE_BUTTONS_LIST } from "../../../../Data/Buttons/EdgeStyle";
import CommonEdgeButton from "../Common/CommonEdgeButton";

const EdgeOutlineSmallButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={OutlineSmallButton} span={EDGE_SMALL_OUTLINE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn size="sm" outline color="primary" id="Tooltip-61" className="btn-pill">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-61" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-outline-primary btn-sm</ToolTip>
          {EDGE_SMALL_OUTLINE_BUTTONS_LIST.map((data, index) => (
            <CommonEdgeButton key={index} item={data} outline size="sm"/>
          ))}
        </CardBody>
      </Card>
    );
};

export default EdgeOutlineSmallButtons;
